import { ChakraComponents as CC } from '@Modules/core/lib/chakra';
import AcquirerRiskManagementLevelFormHandle from '../../containers/forms/base/acquirerRiskManagementLevel/AcquirerRMLFormHandle';
import AcquirerRiskManagementParametersFormHandle from '../../containers/forms/base/acquirerRiskManagementParameters/AcquirerRMPFormHandle';
import IssuerRiskManagementLevelFormHandle from '../../containers/forms/base/issuerRiskManagementLevel/IssuerRMLFormHandle';
import IssuerRiskManagementParametersFormHandle from '../../containers/forms/base/issuerRiskManagementParameters/IssuerRMPFormHandle';

const BankRiskManagementPage = () => {
  return (
    // TODO: Study how to merge all pages into one page with section containing actual pages
    <CC.Tabs>
      <CC.Box as={'div'} style={{ overflowX: 'auto' }}>
        <CC.TabList>
          <CC.Tab minWidth={'fit-content'}>
            Issuer Risk Management Parameters
          </CC.Tab>

          <CC.Tab minWidth={'fit-content'}>Issuer Risk Management Level</CC.Tab>

          <CC.Tab minWidth={'fit-content'}>
            Acquirer Risk Management Parameters
          </CC.Tab>

          <CC.Tab minWidth={'fit-content'}>
            Acquirer Risk Management Level
          </CC.Tab>
        </CC.TabList>
      </CC.Box>

      <CC.TabPanels>
        <CC.TabPanel>
          <IssuerRiskManagementParametersFormHandle />
        </CC.TabPanel>
        <CC.TabPanel>
          <IssuerRiskManagementLevelFormHandle />
        </CC.TabPanel>
        <CC.TabPanel>
          <AcquirerRiskManagementParametersFormHandle />
        </CC.TabPanel>
        <CC.TabPanel>
          <AcquirerRiskManagementLevelFormHandle />
        </CC.TabPanel>
      </CC.TabPanels>
    </CC.Tabs>
  );
};

export default BankRiskManagementPage;
